// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Payroll_CreatePaymentRuleResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for /payroll/create_payment_rule endpoint
 *
 * Returns the created payment rule record.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Payroll_CreatePaymentRuleResponseDados {
id: number
user_id: string
franchise_id: number
rule_type: string
amount: number
active: number
created_at: string
updated_at: string
frequency?: string
last_payment_date?: string
next_due_date?: string
meta?: string
description?: string
}

export type Payroll_CreatePaymentRuleResponse = ApiResponse<Payroll_CreatePaymentRuleResponseDados>;

registerResponseContract('Payroll_CreatePaymentRuleResponse', {
  id:                { type: 'number',  required: true },
  user_id:           { type: 'string',  required: true },
  franchise_id:      { type: 'number',  required: true },
  rule_type:         { type: 'string',  required: true },
  amount:            { type: 'number',  required: true },
  active:            { type: 'number',  required: true },
  created_at:        { type: 'string',  required: true },
  updated_at:        { type: 'string',  required: true },
  frequency:         { type: 'string',  required: false },
  last_payment_date: { type: 'string',  required: false },
  next_due_date:     { type: 'string',  required: false },
  meta:              { type: 'string',  required: false },
  description:       { type: 'string',  required: false },
})
